exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading[data-v-9aab1c6e]{color:#c26f02}[dir] .panel-heading[data-v-9aab1c6e]{border-bottom:0 solid #c26f02!important}.panel-heading h4[data-v-9aab1c6e]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-9aab1c6e]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-9aab1c6e]{margin-right:-20px;padding-right:10px}.panel-flat[data-v-9aab1c6e]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9aab1c6e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/makeNewOrder.vue
// module id = 965
// module chunks = 0